<template>
  <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
    <Cabecalho :titulo="subimposto.label" :aliquota="subimposto.aliquota" />

    <Separador :dado="subimposto" />

    <Ncm :ncm="subimposto.ncm" />
    <div>
      <Notificacao v-if="subimposto.statusNcm == '0'" :tipo="'revisao'" />
      <GrupoNotificacao v-if="subimposto" removeNota :registro="subimposto" />
    </div>
    <Cabecalho class="cabecalho-acordo" :titulo="'Acordo Comercial'" />
    <Registro>
      <AcordoComercial :dados="subimposto" :classe="imposto.classe" />
    </Registro>

    <BaseLegal :base_legal="subimposto.base_legal" :classe="imposto.classe" />
  </Registro>
</template>

<script>
import AcordoComercial from "@/components/AcordoComercial/AcordoComercial.vue";
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import RegistrosPreferenciaTarifaria from "@/components/RegistrosPreferenciaTarifaria/RegistrosPreferenciaTarifaria.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

export default {
  name: "RegistrosPreferenciaTarifaria",

  props: {
    subimposto: Object | Array,
    imposto: Object | Array
  },

  components: {
    AcordoComercial,
    BaseLegal,
    Cabecalho,
    Descricao,
    QuadroPrincipal,
    GrupoNotificacao,
    RadioButton,
    Registro,
    RegistrosPreferenciaTarifaria,
    Separador,
    Ncm,
    Notificacao
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.cabecalho-acordo {
  margin-bottom: 1rem;
}
</style>
